const config = {
    API_URL: process.env.REACT_APP_API_URL,
    RDPMS_API_URLS: process.env.REACT_APP_API_URL,
    RDPMS_IMAGE_URL: process.env.REACT_APP_IMAGE_URLS,
    RDPMS_SOCKET_URL: process.env.REACT_APP_SOCKET_URLS,
    MOBIUS_API_URL: process.env.REACT_APP_MOBIUS_APP_API_URL,
    RDPMS_APP_BRAND: process.env.REACT_APP_BRAND,

    RDPMS_APP_VC_API_KEY: process.env.REACT_APP_VC_API_KEY,
};

export default config;
